
export const SYSTEM_BOUNDED_KEYS = {
   PREV_FRAME     : { code: 37, label: '🠜', desc: 'Frame Back' },
   NEXT_FRAME     : { code: 39, label: '🠞', desc: 'Frame Forward' },

   PREV_CLIP      : { code: 38, label: '🠝', desc: 'Previous Clip' },
   NEXT_CLIP      : { code: 40, label: '🠟', desc: 'Next Clip' },

   STOP_PLAY      : { code: 75, label: String.fromCharCode(75), desc: 'Stop' },
   TOGGLE_PLAY    : { code: 32, label: 'SPACE', desc: 'Play/Stop' },
   PLAY_FORWARD   : { code: 76, label: String.fromCharCode(76), desc: 'Play Forward' },
   PLAY_FORWARD_2 : { code: 76, label: 'LL', desc: 'Fast Forward 2x' },
   PLAY_FORWARD_4 : { code: 76, label: 'LLL', desc: 'Fast Forward 4x' },
   PLAY_FORWARD_8 : { code: 76, label: 'LLLL', desc: 'Fast Forward 8x' },

   PLAY_BACKWARD  : { code: 74, label: String.fromCharCode(74), desc: 'Play Backward' },
   PLAY_BACKWARD_2: { code: 74, label: 'JJ', desc: 'Rewind 2x' },
   PLAY_BACKWARD_4: { code: 74, label: 'JJJ', desc: 'Rewind 4x' },
   PLAY_BACKWARD_8: { code: 74, label: 'JJJJ', desc: 'Rewind 8x' },

   CUT_IN         : { code: 73, label: String.fromCharCode(73), desc: 'Mark In' },
   CUT_OUT        : { code: 79, label: String.fromCharCode(79), desc: 'Mark Out' },

   ADD_TO_TIMELINE: { code: 65, label: String.fromCharCode(65), desc: 'Add Item' },

   REMOVE_ITEM    : { code: 46, label: 'DEL', desc: 'Remove selected item' },
   MOVE_TO_START  : { code: 36, label: 'HOME', desc: 'Jump to start' },
   MOVE_TO_END    : { code: 35, label: 'END', desc: 'Jump to end' }
};


